import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { registerServiceWorker } from "./utils/pushNotifications";
import { ensureDesktopNotificationPermission } from "./utils/desktopNotifications";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

// Só regista o Service Worker (necessário para receber Web Push) — nunca
// pede permissão de notificação aqui. Isso só acontece por ação explícita
// do utilizador em Configurações > Notificações.
void registerServiceWorker();

// Notificações nativas do SO (desktop/Tauri) — sem efeito nenhum em
// web/mobile (ensureDesktopNotificationPermission() verifica o runtime
// primeiro). Ao contrário do Web Push, é seguro pedir isto no arranque:
// é o comportamento padrão esperado de qualquer app desktop Windows, e o
// WebView2 não suporta Push API de qualquer forma (ver desktopNotifications.js).
void ensureDesktopNotificationPermission();
